import React from 'react'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import Checkbox from 'material-ui/Checkbox'

const hoursArray = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23']

const ProductionOptions = ({ styles, settings, handleChange, handleSelectChange }) => {
  return (
    <div><h2>Production Options</h2>
      <div className="content">
        <SelectField
          value={settings.productionCutoffHr}
          floatingLabelText="Production Cutoff Hour"
          style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
          name="productionCutoffHr"
          floatingLabelStyle={styles.floatingLabelStyle}
          onChange={(event, index, value) => handleSelectChange(event, index, value, 'productionCutoffHr')}
        >
          {hoursArray.map((hour, i) => {
            return <MenuItem key={i} value={i} primaryText={hour} />
          })}
        </SelectField>
        <SelectField
          value={settings.productionCutoffMin}
          floatingLabelText="Production Cutoff Minute"
          style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
          name="productionCutoffMin"
          floatingLabelStyle={styles.floatingLabelStyle}
          onChange={(event, index, value) => handleSelectChange(event, index, value, 'productionCutoffMin')}
        >
          <MenuItem value={0} primaryText="00" />
          <MenuItem value={30} primaryText="30" />
        </SelectField>
        <br /><br /><br />
        <Checkbox
          label="Send To Production"
          defaultChecked={settings.sendToProduction}
          name="sendToProduction"
          onCheck={handleChange}
        />
        <br /><br />
        <Checkbox
          label="Saturday Delivery"
          defaultChecked={settings.productionSatDeliv}
          name="productionSatDeliv"
          onCheck={handleChange}
        />
        <br /><br />
        <Checkbox
          label="Saturday Production"
          defaultChecked={settings.productionSat}
          name="productionSat"
          onCheck={handleChange}
        />
      </div>
    </div>
  )
}

export default ProductionOptions


// WEBPACK FOOTER //
// ./src/components/settings/ProductionOptions.js